/**
 * Каталог сообщений сервера, видимых пользователю: ошибки, хронология розыгрыша, причины отмены.
 *
 * Сервер передаёт сообщение кодом с параметрами (Msg) и, для совместимости и журналов, готовым
 * русским текстом. Клиент переводит код своим словарём (en, de; ru — этот каталог), поэтому
 * сохранённые повторы и пакеты не зависят от языка просмотра.
 *
 * Шаблоны: {name} — подстановка параметра; {name|cr} — сумма в минорных единицах, форматируется как кредиты.
 * Параметр может быть вложенным сообщением (например, причина отмены внутри записи хронологии).
 */

export const MESSAGES_RU = {
  // ── соединение и сессия ──
  'err.rateLimited': 'слишком много запросов, подождите',
  'err.badMessage': 'некорректное сообщение',
  'err.internal': 'внутренняя ошибка сервера',
  'err.adminNoPlay': 'администратор не участвует в игре',
  'err.authRequired': 'требуется вход',
  'err.adminRequired': 'требуется вход администратора',
  'err.adminOnly': 'доступно только администратору',
  'err.sessionExpired': 'сессия не найдена или истекла — войдите заново',
  'err.badData': 'некорректные данные',
  'err.tooManyConnections': 'слишком много соединений',
  // ── столы ──
  'err.roomNotFound': 'стол не найден',
  'err.unknownCategory': 'неизвестная категория стола',
  'err.lowBalanceTable': 'недостаточно кредитов для взноса этого стола',
  'err.lowBalance': 'недостаточно кредитов для взноса',
  'err.inOtherGame': 'вы участвуете в розыгрыше за другим столом',
  'err.notSeated': 'вы не сидите за столом',
  'err.notInGame': 'вы не участвуете в текущем розыгрыше',
  'err.notParticipant': 'вы не участвуете в этом розыгрыше',
  'err.gameFinished': 'розыгрыш завершён',
  'room.notStarted': 'Розыгрыш не начат: {detail}',
  // ── учётная запись ──
  'err.banned': 'учётная запись заблокирована',
  'err.bannedReason': 'учётная запись заблокирована: {reason}',
  'err.accountNotFound': 'учётная запись не найдена',
  'err.userNotFound': 'пользователь не найден',
  'err.playerNotFound': 'игрок не найден',
  'err.badReason': 'некорректная причина',
  'err.noBanBots': 'ботов не блокируют',
  'err.botBalanceAuto': 'баланс ботов пополняется автоматически',
  'err.botTopUpOnly': 'пополнение доступно только ботам',
  'err.resetDuringGame': 'сброс баланса недоступен во время розыгрыша — дождитесь расчёта',
  'err.nameShort': 'имя должно содержать минимум 2 символа',
  'err.nameChars': 'в имени допустимы буквы, цифры, пробел, точка, дефис и подчёркивание',
  'err.nameBot': 'имя не должно выдавать себя за бота',
  'err.nameTaken': 'это имя уже занято — выберите другое',
  // ── вход и регистрация ──
  'err.loginFormat': 'логин: 3–32 символа — латинские буквы, цифры, точка, дефис, подчёркивание; начинается с буквы или цифры',
  'err.loginTaken': 'этот логин занят',
  'err.registerRateLimited': 'слишком много регистраций с этого адреса, попробуйте позже',
  'err.loginRateLimited': 'слишком много попыток входа — подождите несколько минут',
  'err.loginInvalid': 'неверный логин или пароль',
  'err.registerFields': 'заполните логин, пароль и имя',
  'err.loginFields': 'укажите логин и пароль',
  'err.passwordMissing': 'укажите новый пароль',
  'err.passwordCurrentWrong': 'текущий пароль указан неверно',
  'err.passwordShort': 'пароль должен содержать не меньше 8 символов',
  'err.passwordLong': 'пароль слишком длинный (не больше 128 символов)',
  'err.passwordLetters': 'в пароле должны быть буквы и цифры',
  'err.sessionNotFound': 'сессия не найдена — войдите заново',
  'err.providerLinkedOther': 'эта учётная запись {provider} уже привязана к другому игроку',
  'err.providerOtherLinked': 'к профилю уже привязана другая учётная запись {provider}',
  'err.providerNotLinked': 'этот провайдер не привязан',
  'err.providerLastMethod': 'нельзя отвязать единственный способ входа — сначала задайте логин и пароль',
  'err.oauthNotConfigured': 'вход через этого провайдера не настроен',
  'err.oauthTooMany': 'слишком много незавершённых входов, попробуйте позже',
  'err.oauthState': 'запрос входа устарел или подделан — начните вход заново',
  'err.oauthProfile': 'провайдер вернул {status} при запросе профиля',
  'err.oauthNoToken': 'провайдер не выдал токен',
  'err.oauthNoTokenDetail': 'провайдер не выдал токен: {detail}',
  'err.oauthNoSubject': 'провайдер не сообщил идентификатор пользователя',
  'err.oauthCancelled': 'вход отменён',
  'err.oauthProviderError': 'провайдер сообщил об ошибке: {detail}',
  'err.oauthIncomplete': 'неполный ответ провайдера',
  'err.oauthFailed': 'не удалось выполнить вход через провайдера — попробуйте позже',
  // ── история ──
  'err.gameNotFound': 'розыгрыш не найден',
  'err.replayParticipantsOnly': 'запись доступна только участникам розыгрыша',
  'err.packageNotFound': 'пакет проверки для этого розыгрыша не найден',
  'err.packageParticipantsOnly': 'пакет доступен только участникам розыгрыша',
  // ── ходы и прогноз ──
  'err.forecastLocked': 'прогноз уже зафиксирован',
  'err.betsLocked': 'ставки уже зафиксированы',
  'err.folded': 'вы вышли из розыгрыша',
  'err.directionAfterRound1': 'после первого круга направление менять нельзя — можно изменить только число пунктов',
  'err.directionRound3': 'в третьем круге направление менять нельзя — можно изменить только число пунктов',
  'err.directionAllIn': 'в олл-ине направление нельзя снять',
  'err.pointsInvalid': 'число пунктов должно быть строго положительным и кратным шагу цены',
  'err.pointsInvalidTick': 'число пунктов должно быть строго положительным и кратным {tick}',
  'err.pointsAllIn': 'в олл-ине прогноз пунктов нельзя снять',
  'err.autoLimit': 'укажите лимит авто-колла',
  'err.noBetting': 'сейчас нет круга ставок',
  'err.notYourTurn': 'сейчас не ваш ход',
  'err.directionFirst': 'сначала выберите направление: выше или ниже',
  'err.allInPoints': 'перед олл-ином укажите предварительное число пунктов',
  'err.checkToCall': 'чек невозможен: есть ставка для уравнивания',
  'err.callNothing': 'нечего уравнивать — используйте чек',
  'err.betExists': 'ставка уже сделана — используйте колл или райз',
  'err.betMin': 'минимальная ставка {amount|cr}',
  'err.creditsLow': 'недостаточно кредитов',
  'err.raiseNoBet': 'нет ставки для повышения — используйте «ставка»',
  'err.raiseLimit': 'лимит повышений в этом круге исчерпан',
  'err.raiseMin': 'повышение минимум до {amount|cr}',
  'err.creditsNone': 'нет доступных кредитов',
  'err.allInRaiseLimit': 'лимит повышений исчерпан — доступен только колл',
  'err.actionUnknown': 'неизвестное действие',
  // ── причины отмены и завершения ──
  'reason.noAntes': 'нет взносов',
  'reason.allOut': 'все участники выбыли',
  'reason.walkover': 'все остальные участники спасовали',
  'reason.walkoverMulti': 'внутренняя ошибка: walkover при нескольких участниках',
  'reason.flat': 'P₁ = P₀: ни «выше», ни «ниже» не наступило',
  'reason.noneCorrect': 'никто из оставшихся игроков не угадал направление',
  'reason.noResult': 'нет достоверного результата: {detail}',
  'reason.sourceDown': 'нет достоверного результата: источник данных недоступен',
  'reason.serverStop': 'остановка сервера',
  // ── хронология розыгрыша ──
  'log.created': 'Розыгрыш создан. Обязательство: {commitment}…',
  'log.antes': 'Взносы по {ante|cr} внесены в банк. P₀ = {p0}.',
  'log.round1': 'Круг 1: график агрегата и выбор направления. Шкала цен скрыта.',
  'log.round2': 'Круг 2: открыта шкала цен и расстояний в пунктах.',
  'log.round3': 'Круг 3: раскрыт состав агрегата — {composition}. Укажите число пунктов.',
  'log.openInstrument': 'Инструмент: {symbol} ({name}). Цена открыта с начала розыгрыша.',
  'log.open.round1': 'Круг 1: выбор направления. После круга 1 направление не меняется.',
  'log.open.round2': 'Круг 2: направление зафиксировано, уточняйте число пунктов.',
  'log.open.round3': 'Круг 3: последний круг. Укажите число пунктов.',
  'log.locked': 'Прогнозы и ставки зафиксированы. Формируется целевая минутная свеча.',
  'log.uncalledReturn': '{name}: неуравнённая часть ставки {amount|cr} возвращена',
  'log.autoFoldNoForecast': '{name}: автоматический пас — не указал полный прогноз к фиксации',
  'log.autoFoldTimeout': '{name}: автоматический пас — истекло время хода',
  'log.roundClosed': 'Круг {round}: ставки завершены',
  'log.settled': 'Расчёт выполнен.',
  'log.cancelled': 'Розыгрыш отменён: {reason}. Взносы возвращены, комиссия не удержана.',
} as const satisfies Record<string, string>;

export type MsgCode = keyof typeof MESSAGES_RU;
export type MsgParam = string | number | Msg;
export interface Msg {
  code: MsgCode;
  params?: Record<string, MsgParam>;
}
/** Словарь сообщений сервера на одном языке: все коды обязательны. */
export type MessageCatalog = Record<MsgCode, string>;

export const msg = (code: MsgCode, params?: Record<string, MsgParam>): Msg => (params ? { code, params } : { code });

/**
 * Подстановка параметров в шаблон каталога. credits форматирует {x|cr}; вложенные сообщения
 * переводятся тем же каталогом. Неизвестный код — сам код (клиент старее сервера).
 */
export function formatMsg(catalog: MessageCatalog, m: Msg, credits: (minor: number) => string): string {
  const template = catalog[m.code] ?? MESSAGES_RU[m.code] ?? m.code;
  return template.replace(/\{(\w+)(\|cr)?\}/g, (whole, key: string, cr?: string) => {
    const v = m.params?.[key];
    if (v === undefined) return whole;
    if (typeof v === 'object') return formatMsg(catalog, v, credits);
    return cr && typeof v === 'number' ? credits(v) : String(v);
  });
}

/**
 * Ошибка предметной области с кодом сообщения. message — русский текст (журналы, совместимость),
 * msg — код и параметры для перевода на клиенте.
 */
export class CodedError extends Error {
  readonly msg: Msg;
  constructor(code: MsgCode, params?: Record<string, MsgParam>) {
    const m = msg(code, params);
    super(msgRu(m));
    this.msg = m;
  }
}

/** Русский текст сообщения (сервер: журналы, поле text записей, сообщения об ошибках). */
export function msgRu(m: Msg): string {
  return formatMsg(MESSAGES_RU, m, formatCredits);
}

/** Сумма кредитов по-русски: «10 000 кр.», «12,50 кр.» (минорные единицы — сотые). */
export function formatCredits(minor: number): string {
  const sign = minor < 0 ? '−' : '';
  const abs = Math.abs(minor);
  const whole = Math.floor(abs / 100);
  const frac = abs % 100;
  return `${sign}${whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}${frac ? ',' + frac.toString().padStart(2, '0') : ''} кр.`;
}
